"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var calcData = {
  normal: {
    taxRate: 0.22,
    socialInsuranceDisable: 0.029,
    oms: 0.051
  },
  hight: {
    taxRate: 0.1,
    socialInsuranceDisable: 0,
    oms: 0
  },
  limitOfBaseOPS: 1292000,
  limitOfBaseOSS: 912000
};
var _default = calcData;
exports.default = _default;